import { SkapaElement } from "@ingka/skapa-webc-element";
import { SlotTools } from "@ingka/webc-tools";
import { Button, IconButton } from "@ingka/button-webc/passive.js";
import { Icon } from "@ingka/icon-webc/passive.js";
import { arrowRight } from "@ingka/icon-store";
const styles = ':host{--content-card-background:rgb(var(--colour-neutral-2,245,245,245));--content-card-foreground:rgb(var(--colour-text-and-icon-1,17,17,17));display:flex;flex-direction:column-reverse;position:relative}.content-card{display:flex;flex-direction:column;flex-grow:1;justify-content:space-between}:host(:not([simple])) .content-card{background:var(--content-card-background);padding:2rem}:host([vertical-center]) .content-card{justify-content:center}:host([simple]) .content-card{justify-content:flex-start}:host([simple]) .container{padding-inline-end:1rem}.headers{color:var(--content-card-foreground);display:block;margin-bottom:.5rem;text-decoration:none}.headers:before{bottom:0;content:"";left:0;position:absolute;right:0;top:0}:host(:hover) [name=title]::slotted(*){text-decoration:underline}slot[name=add-on]{display:block;margin-bottom:.5rem}slot[name=add-on],slot[name=label]{color:rgb(var(--colour-text-and-icon-2,72,72,72))}slot[name=label]{display:inline-block;font-size:.75rem;line-height:1.5;margin-bottom:.25rem}slot[name=title]{color:rgb(var(--colour-text-and-icon-1,17,17,17));font-size:1.5rem;font-weight:700;letter-spacing:-.0042em;line-height:1.45}@media (min-width:37.5em){slot[name=title]{font-size:2.25rem;letter-spacing:-.0063em;line-height:1.333}}slot[name=subtitle]{color:rgb(var(--colour-text-and-icon-1,17,17,17));font-weight:700}slot[name=body],slot[name=subtitle]{display:block;font-size:.875rem;line-height:1.571}slot[name=body]{color:rgb(var(--colour-text-and-icon-2,72,72,72));margin-top:.75rem}:host([fixed]) [name=title]{font-size:1.5rem;letter-spacing:-.0042em;line-height:1.45}a:focus{outline:none}a:focus-visible:before{box-shadow:0 0 0 4px var(--skapa-focus-ring-internal,rgb(var(--colour-neutral-1,255,255,255)));outline:2px solid var(--skapa-focus-ring-external,rgb(var(--colour-neutral-7,17,17,17)));outline-offset:4px;transition:outline .2s ease-out,box-shadow .2s ease-out}.container{max-width:37.5rem}.footer{margin-top:1.5rem}#btn+[icon]{display:none}:host([simple]) #btn{display:none}:host([simple]) #btn+[icon]{display:block}[name=media]::slotted(*){width:100%}[name=media]::slotted(skapa-aspect-ratio){display:flex}@media (min-width:56.25em){:host(:not([fixed])){flex-direction:row-reverse}:host(:not([fixed])) [name=body]{margin-top:1rem}:host(:not([fixed])) .footer{margin-top:2rem}:host([trailing-media]){flex-direction:row}:host([fixed]){flex-direction:column-reverse}:host(:not([fixed])) .content-card:is([with-media]){padding:3rem}:host([simple]:not([fixed])) .content-card:is([with-media]){padding:0 3rem}:host([trailing-media][simple]:not([fixed])) .content-card:is([with-media]){padding-inline-start:0}:host([simple]:not([fixed])) .content-card:is([with-media]) .container{padding-inline-end:unset}}slot:is(.skapa-empty){display:none}:host([theme=importantMessage]){--content-card-background:rgb(var(--colour-neutral-7,17,17,17));--content-card-foreground:rgb(var(--colour-text-and-icon-5,255,255,255))}:host([theme=inverse]){--content-card-background:rgb(var(--colour-elevation-2,255,255,255))}:host([theme=wayfinding]){--content-card-background:rgb(var(--colour-static-ikea-brand-blue,0,88,163));--content-card-foreground:rgb(var(--colour-static-white,255,255,255))}:host([theme=lowestPrice]){--content-card-background:rgb(var(--colour-commercial-message-bti-yellow,255,219,0));--content-card-foreground:rgb(var(--colour-static-black,17,17,17))}:host([theme=newLowerPrice]){--content-card-background:rgb(var(--colour-commercial-message-new-lower-price,204,0,8));--content-card-foreground:rgb(var(--colour-text-and-icon-5,255,255,255))}:host([theme=new]){--content-card-background:rgb(var(--colour-commercial-message-new,202,80,8));--content-card-foreground:rgb(var(--colour-text-and-icon-5,255,255,255))}:host([theme=IKEAFamily]){--content-card-background:rgb(var(--colour-static-ikea-family,0,124,193));--content-card-foreground:rgb(var(--colour-text-and-icon-5,255,255,255))}:host([theme=sustainability]){--content-card-background:rgb(var(--colour-campaign-sustainability,0,133,62));--content-card-foreground:rgb(var(--colour-text-and-icon-5,255,255,255))}:host([theme=IKEABusinessNetwork]){--content-card-background:rgb(var(--colour-static-ikea-business-network,222,188,156));--content-card-foreground:rgb(var(--colour-static-black,17,17,17))}:host([theme=extendedPalette01]){--content-card-background:rgb(var(--colour-extended-palette-01,193,207,212));--content-card-foreground:rgb(var(--colour-static-black,17,17,17))}:host([theme=extendedPalette02]){--content-card-background:rgb(var(--colour-extended-palette-02,163,172,176));--content-card-foreground:rgb(var(--colour-static-black,17,17,17))}:host([theme=extendedPalette03]){--content-card-background:rgb(var(--colour-extended-palette-03,140,221,255));--content-card-foreground:rgb(var(--colour-static-black,17,17,17))}:host([theme=extendedPalette04]){--content-card-background:rgb(var(--colour-extended-palette-04,0,150,210));--content-card-foreground:rgb(var(--colour-static-black,17,17,17))}:host([theme=extendedPalette05]){--content-card-background:rgb(var(--colour-extended-palette-05,0,89,128));--content-card-foreground:rgb(var(--colour-static-white,255,255,255))}:host([theme=extendedPalette06]){--content-card-background:rgb(var(--colour-extended-palette-06,217,171,255));--content-card-foreground:rgb(var(--colour-static-black,17,17,17))}:host([theme=extendedPalette07]){--content-card-background:rgb(var(--colour-extended-palette-07,107,61,153));--content-card-foreground:rgb(var(--colour-static-white,255,255,255))}:host([theme=extendedPalette08]){--content-card-background:rgb(var(--colour-extended-palette-08,255,166,218));--content-card-foreground:rgb(var(--colour-static-black,17,17,17))}:host([theme=extendedPalette09]){--content-card-background:rgb(var(--colour-extended-palette-09,229,47,126));--content-card-foreground:rgb(var(--colour-static-black,17,17,17))}:host([theme=extendedPalette10]){--content-card-background:rgb(var(--colour-extended-palette-10,255,174,102));--content-card-foreground:rgb(var(--colour-static-black,17,17,17))}:host([theme=extendedPalette11]){--content-card-background:rgb(var(--colour-extended-palette-11,255,170,0));--content-card-foreground:rgb(var(--colour-static-black,17,17,17))}:host([theme=extendedPalette12]){--content-card-background:rgb(var(--colour-extended-palette-12,242,106,47));--content-card-foreground:rgb(var(--colour-static-black,17,17,17))}:host([theme=extendedPalette13]){--content-card-background:rgb(var(--colour-extended-palette-13,204,177,0));--content-card-foreground:rgb(var(--colour-static-black,17,17,17))}:host([theme=extendedPalette14]){--content-card-background:rgb(var(--colour-extended-palette-14,199,217,0));--content-card-foreground:rgb(var(--colour-static-black,17,17,17))}:host([theme=extendedPalette15]){--content-card-background:rgb(var(--colour-extended-palette-15,122,181,29));--content-card-foreground:rgb(var(--colour-static-black,17,17,17))}:host([theme=extendedPalette16]){--content-card-background:rgb(var(--colour-extended-palette-16,80,128,32));--content-card-foreground:rgb(var(--colour-static-white,255,255,255))}:host([theme=extendedPalette17]){--content-card-background:rgb(var(--colour-extended-palette-17,149,229,187));--content-card-foreground:rgb(var(--colour-static-black,17,17,17))}:host([theme=extendedPalette18]){--content-card-background:rgb(var(--colour-extended-palette-18,0,153,133));--content-card-foreground:rgb(var(--colour-static-black,17,17,17))}:host([theme=extendedPalette19]){--content-card-background:rgb(var(--colour-extended-palette-19,0,102,88));--content-card-foreground:rgb(var(--colour-static-white,255,255,255))}:host([theme=extendedPalette20]){--content-card-background:rgb(var(--colour-extended-palette-20,215,199,162));--content-card-foreground:rgb(var(--colour-static-black,17,17,17))}:host([theme=extendedPalette21]){--content-card-background:rgb(var(--colour-extended-palette-21,195,178,137));--content-card-foreground:rgb(var(--colour-static-black,17,17,17))}:host(:not([simple],[theme=inverse],[theme=default])) slot:not(:is([name=media])){color:var(--content-card-foreground)}';
const lightStyles = 'skapa-card>:not(:is([slot=add-on])){color:inherit;font-size:inherit;line-height:inherit;margin:inherit}skapa-card>skapa-aspect-ratio:has(>skapa-image){pointer-events:none}';
function generateTemplate({ html, prefixReplacer }) {
  const template = document.createElement("template");
  template.innerHTML = html` <style>
      ${styles}
    </style>
    <div class="content-card">
      <div class="container">
        <slot name="add-on"></slot>
        <slot name="label"></slot>
        <a class="headers" aria-describedby="cta">
          <slot name="title">Title is required</slot>
        </a>
        <slot name="subtitle"></slot>
        <slot name="body"></slot>
      </div>
      <div class="footer">
        <slot name="button" id="cta">
          <skapa-button
            id="btn"
            decorative-only
            variant="primary"
            icon-only
            inverse
            static-colour
            size="small"
          >
            <skapa-icon icon="arrow-right" slot="icon"></skapa-icon>
            <slot name="button-text"></slot>
          </skapa-button>
          <skapa-icon icon="arrow-right"></skapa-icon>
        </slot>
      </div>
    </div>
    <slot name="media"></slot>
    <slot name="light-styles"></slot>`;
  const lightStyleTemplate = document.createElement("style");
  lightStyleTemplate.slot = "light-styles";
  lightStyleTemplate.innerHTML = prefixReplacer(lightStyles.toString());
  return { main: template, lightStyleTemplate };
}
const lightForegroundThemes = [
  "importantMessage",
  "new",
  "sustainability",
  "IKEAFamily",
  "newLowerPrice"
];
const staticDarkForgroundThemes = [
  "lowestPrice",
  "IKEABusinessNetwork",
  "extendedPalette01",
  "extendedPalette02",
  "extendedPalette03",
  "extendedPalette04",
  "extendedPalette06",
  "extendedPalette08",
  "extendedPalette09",
  "extendedPalette10",
  "extendedPalette11",
  "extendedPalette12",
  "extendedPalette13",
  "extendedPalette14",
  "extendedPalette15",
  "extendedPalette17",
  "extendedPalette18",
  "extendedPalette20",
  "extendedPalette21"
];
const staticLightForegroundThemes = [
  "wayfinding",
  "extendedPalette05",
  "extendedPalette07",
  "extendedPalette16",
  "extendedPalette19"
];
class Card extends SkapaElement {
  constructor() {
    super();
    this.handleMediaMode = (target) => {
      this.contentCardRef.toggleAttribute(
        "with-media",
        Boolean(target.assignedElements({ flatten: true }).length)
      );
    };
    this.reflectHref = () => {
      this.link.setAttribute("href", this.url);
    };
    this.syncButtonTheme = () => {
      const theme = this.theme;
      this.innerButton.toggleAttribute("inverse", theme !== "inverse");
      this.innerButton.toggleAttribute("static-colour", theme !== "inverse");
      const button = this.slottedButton.assignedElements({ flatten: true })[0];
      if (!button || button === this.innerButton) return;
      const lightForeground = lightForegroundThemes.includes(theme);
      const staticLightForeground = staticLightForegroundThemes.includes(theme);
      const staticDarkForeground = staticDarkForgroundThemes.includes(theme);
      button.setAttribute("decorative-only", "");
      button.setAttribute("size", "small");
      button.toggleAttribute("inverse", lightForeground || staticLightForeground);
      button.toggleAttribute(
        "static-colour",
        staticDarkForeground || staticLightForeground
      );
    };
    this.onSlotChange = ({
      target
    }) => {
      SlotTools.checkSlot(target);
      if (target.name === "media") {
        this.handleMediaMode(target);
      } else if (target.name === "button") {
        this.syncButtonTheme();
      }
    };
    this.gatherProperties(
      [
        "trailingMedia",
        "url",
        "simple",
        "target",
        "fixed",
        "theme",
        "verticalCenter"
      ],
      this
    );
    const shadow = this.attachShadow({ mode: "open", delegatesFocus: true });
    const { main, lightStyleTemplate } = this.getTemplates(generateTemplate);
    shadow.append(main.content.cloneNode(true));
    this.link = this.get$("a");
    this.innerButton = this.get$("skapa-button");
    this.slottedButton = this.get$("slot[name=button]");
    this.__lightStyleNode = lightStyleTemplate.cloneNode(
      true
    );
    this.contentCardRef = this.get$(".content-card");
  }
  set trailingMedia(val) {
    this.toggleAttribute("trailing-media", !!val);
  }
  get trailingMedia() {
    return this.hasAttribute("trailing-media");
  }
  set fixed(val) {
    this.toggleAttribute("fixed", !!val);
  }
  get fixed() {
    return this.hasAttribute("fixed");
  }
  set theme(theme) {
    if (theme !== "default" || !theme) {
      this.removeAttribute("theme");
      return;
    }
    this.setAttribute("theme", theme);
  }
  get theme() {
    return this.getAttribute("theme") || "default";
  }
  set simple(val) {
    this.toggleAttribute("simple", !!val);
  }
  get simple() {
    return this.hasAttribute("simple");
  }
  set verticalCenter(val) {
    this.toggleAttribute("vertical-center", !!val);
  }
  get verticalCenter() {
    return this.hasAttribute("vertical-center");
  }
  set target(value) {
    if (value) this.setAttribute("target", value);
    else this.removeAttribute("target");
  }
  get target() {
    return this.link.getAttribute("target");
  }
  set url(value) {
    if (value) this.setAttribute("url", value);
    else this.removeAttribute("url");
  }
  get url() {
    return this.getAttribute("url") || "";
  }
  connectedCallback() {
    super.connectedCallback();
    this.shadowRoot.addEventListener(
      "slotchange",
      this.onSlotChange,
      { passive: true }
    );
    Array.from(this.shadowRoot.querySelectorAll("slot")).map(
      SlotTools.checkSlot
    );
    this.syncButtonTheme();
    this.reflectHref();
    this.append(this.__lightStyleNode);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.shadowRoot.removeEventListener(
      "slotchange",
      this.onSlotChange
    );
  }
  attributeChangedCallback(name, oldval, newVal) {
    if (name === "url") {
      if (newVal) {
        this.link.setAttribute("href", newVal);
      } else {
        this.link.removeAttribute("href");
      }
    } else if (name === "theme" && !this.simple) {
      this.micro(this.syncButtonTheme);
    } else if (name === "target") {
      if (newVal) {
        this.link.setAttribute("target", newVal);
      } else {
        this.link.removeAttribute("target");
      }
    }
  }
}
Card.skapaTagName = "card";
Card.skapaDependencies = [Button, IconButton, Icon];
Card.skapaIconDependencies = [arrowRight];
Card.observedAttributes = ["url", "target", "theme"];
var Card_default = Card;
export {
  Card,
  Card_default as default
};
